import { getAdmin } from '../services/auth';
import type { Admin, AdminRole } from '../types/api';

interface CurrentAdmin extends Admin {
  name?: string;
}

interface CurrentAdminHelpers {
  admin: CurrentAdmin | null;
  role: AdminRole | null;
  isRoot: () => boolean;
  isAdmin: () => boolean;
  isSupervisor: () => boolean;
  isSeller: () => boolean;
  canEdit: () => boolean;
  canManageAdmins: () => boolean;
  canSendEmails: () => boolean;
  canViewReports: () => boolean;
}

const MANAGEMENT_ROLES: AdminRole[] = ['root', 'admin'];
const SELLER_ROLES: AdminRole[] = ['backseller', 'telemarket'];
// Supervisor edita poco — solo reasignación. No incluido en EDIT_ROLES amplio.
const EDIT_ROLES: AdminRole[] = ['root', 'admin', 'backseller'];
const EMAIL_ROLES: AdminRole[] = ['root', 'admin', 'backseller'];
const REPORT_ROLES: AdminRole[] = ['root', 'admin', 'supervisor', 'viewer'];

export function useCurrentAdmin(): CurrentAdminHelpers {
  const admin = getAdmin() as CurrentAdmin | null;
  const role = admin?.role ?? null;

  return {
    admin,
    role,
    isRoot: () => role === 'root',
    isAdmin: () => MANAGEMENT_ROLES.includes(role!),
    isSupervisor: () => role === 'supervisor',
    isSeller: () => SELLER_ROLES.includes(role!),
    canEdit: () => EDIT_ROLES.includes(role!),
    canManageAdmins: () => MANAGEMENT_ROLES.includes(role!),
    canSendEmails: () => EMAIL_ROLES.includes(role!),
    canViewReports: () => REPORT_ROLES.includes(role!),
  };
}
